import Route from '@ember/routing/route';
import { set, get } from '@ember/object';
import { service } from '@ember/service';
import ENV from 'donor-elf-web/config/environment';

export default Route.extend({
  fundsService: service(),
  store: service(),
  navbarSettings: service(),

  beforeModel() {
    set(this, 'navbarSettings.title', 'View Classic Site');
    return this.fundsService.confirmValidFundToken();
  },

  model() {
    return this.store.findRecord('classic-site-token', 1).then((record) => {
      let token = get(record, 'token');
      window.location = `${ENV.apiUrl}/users/login?token=${token}&token_type=classic_site_token`;
    });
  },
});
